export default __webpack_public_path__ + "static/media/wikipedia-icon.eec1a09d.svg";